import { CartDeliveryOptions } from "@src/backbone/model/CartModel";
import { useTranslation } from "@src/hooks/useTranslation";
import { IPreorderOptions } from "@src/store/reducers/CartSlice/cart.interface";
import DeliveryOptionsStatus from "design-system/src/Components/DeliveryOptionsStatus/DeliveryOptionsStatus";
import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { cartSlice } from "@src/store/reducers/CartSlice";

export interface IDeliveryOptionsProps {
  wrapper?: "Navigation" | "Cart";
  drawerOnly?: boolean;
  drawerOpen?: boolean;
  onSuccess?: () => void;
  onConfirm?: () => void;
  onCloseDrawer?: () => void;
  preorder?: IPreorderOptions;
  preset?: Partial<CartDeliveryOptions>;
  forceShowStatus?: boolean;
  isAddAddress?: boolean;
}

const DeliveryOptionsListingFallback = (props: IDeliveryOptionsProps) => {
  const { forceShowStatus } = props;
  const { t } = useTranslation(["Cart"]);
  const dispatch = useDispatch();
  const searchLabel = t("Saisissez votre adresse", "Cart");
  const selectLabel = t("En livraison", "Cart");

  const openDeliveryOptions = useCallback(() => {
    dispatch(cartSlice.actions.openDeliveryOptions({}));
  }, [dispatch]);

  return (
    <DeliveryOptionsStatus
      visible={forceShowStatus}
      search={true}
      searchLabel={searchLabel}
      selectLabel={selectLabel}
      style={{ flex: 1 }}
      onClick={openDeliveryOptions}
    />
  );
};

export default DeliveryOptionsListingFallback;
